
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexPfDXZz_3oryn83dYnN6J_XYP2LTf3h0N_45pjWJqoXWZgMeta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/index.vue?macro=true";
import { default as indexS_RVkB2C_45xmh621KY58lww1RWzjuYU5YasFIFDm1fqMMeta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/player/index.vue?macro=true";
import { default as playerOzIe_Cg4hhxe4aHXlZhzAh3nkRWvO1knBUePmhG51toMeta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/player.vue?macro=true";
import { default as about_45usKBP2Eo8pUdFy9kzAqUNKcTLJZosi3BDC1XHreObPCK4Meta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings/about-us.vue?macro=true";
import { default as dev_45mode_45SFEsY0VgJol_T02F1Vm_TST524QeVeDTfRjSdmDG0gMeta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings/dev-mode.vue?macro=true";
import { default as clear_45cachegvD3PHLjDxUhZxeDRRGC25hpuIqBmueA31vrWIarmWUMeta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings/clear-cache.vue?macro=true";
import { default as indexYlweKTTNBZbhYscKDbT4qt9iSWNVf3ehfeGM3kRLAnkMeta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings/player/index.vue?macro=true";
import { default as indexm4w5cXr2_45me8k7Z_m6Q4WLGjvo8UvqNz_45Nr30d51o20Meta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings/language/index.vue?macro=true";
import { default as settingsPZF1AmchPH1KTcETi_45pPSypGynkqxgtf3h8XWH1mDwkMeta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings.vue?macro=true";
import { default as app_45errortAd5u04YpkM9MHOruIg4lZ5K6yx0SpompmSJOqXak_454Meta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/app-error.vue?macro=true";
import { default as indexqZoQy_458vLU_45ZTs1wUE_hqmcUNl9dbu4JXsqD8Ki59WEMeta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/home/index.vue?macro=true";
import { default as index00t_PjKvKplawVUpNgF8gcLOuYuwk_oQs6wBPYeEEQ8Meta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/login/index.vue?macro=true";
import { default as logo99G2klLm79lDFJ1OZG0S0_45lnSJNGI338HlDOLcVgqt0Meta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/splash/logo.vue?macro=true";
import { default as maxiU9VJhOMeQJnLlY5jgc038oj4fghPxLLLamTlmPHvn2EMeta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/splash/maxi.vue?macro=true";
import { default as loaderfNksF7H9oX0ifUAnhHGU7Xve8G7nwTUjVPwFJVLFmLoMeta } from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/splash/loader.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexPfDXZz_3oryn83dYnN6J_XYP2LTf3h0N_45pjWJqoXWZgMeta || {},
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/index.vue")
  },
  {
    name: playerOzIe_Cg4hhxe4aHXlZhzAh3nkRWvO1knBUePmhG51toMeta?.name,
    path: "/player",
    meta: { ...(playerOzIe_Cg4hhxe4aHXlZhzAh3nkRWvO1knBUePmhG51toMeta || {}), ...{"middleware":["set-page-indicator"]} },
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/player.vue"),
    children: [
  {
    name: "player",
    path: "",
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/player/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings.vue"),
    children: [
  {
    name: "settings-about-us",
    path: "about-us",
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings/about-us.vue")
  },
  {
    name: "settings-dev-mode",
    path: "dev-mode",
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings/dev-mode.vue")
  },
  {
    name: "settings-clear-cache",
    path: "clear-cache",
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings/clear-cache.vue")
  },
  {
    name: "settings-player",
    path: "player",
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings/player/index.vue")
  },
  {
    name: "settings-language",
    path: "language",
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/settings/language/index.vue")
  }
]
  },
  {
    name: "app-error",
    path: "/app-error",
    meta: app_45errortAd5u04YpkM9MHOruIg4lZ5K6yx0SpompmSJOqXak_454Meta || {},
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/app-error.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: {"middleware":["set-page-indicator","fetch-home"]},
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/home/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: index00t_PjKvKplawVUpNgF8gcLOuYuwk_oQs6wBPYeEEQ8Meta || {},
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/login/index.vue")
  },
  {
    name: "splash-logo",
    path: "/splash/logo",
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/splash/logo.vue")
  },
  {
    name: "splash-maxi",
    path: "/splash/maxi",
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/splash/maxi.vue")
  },
  {
    name: "splash-loader",
    path: "/splash/loader",
    component: () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/pages/splash/loader.vue")
  }
]